import React from "react";
import { STYLE_MAX_WIDTH_DESKTOP } from "../../utils/useStyle";
import HomeBanner from "./render/Home.Banner";
import HomeFaq from "./render/Home.Faq";
import HomeHowItWorks from "./render/Home.Howitworks";
import HomeProgram from "./render/Home.Program";
import HomeWelcome from "./render/Home.Welcome";
import MetaTags from "../../utils/useMetaTags";
import { ContextLanguage } from "../../context/Context.Language";
import HomeText from "./render/Home.Text";

const HomeMain = React.memo(({ programs, config, banner }) => {
  const { language } = React.useContext(ContextLanguage);

  return (
    <React.Fragment>
      {language === "TH" ? (
        <MetaTags
          description="มายลอนดรี้ คือร้านซักอบรีดและซักรองเท้าเดลิเวอรี่ในกรุงเทพ เรารับประกันว่าจะส่งฟรีถึงบ้านภายใน 12:00 น. ของวันถัดไป ✅ สะดวกและรวดเร็ว! สั่งเลย!"
          title="ซักอบรีด กรุงเทพ 🧺👕 เดลิเวอรี่ ฟรี | My Laundry"
        />
      ) : (
        <MetaTags
          description="My Laundry is your professional laundry & shoe cleaning service in Bangkok. We guarantee FREE next-day delivery by 12:00 ✅ Fast & easy! Order NOW!"
          title="Laundry Service Bangkok 🧺👕 FREE Delivery | My Laundry"
        />
      )}

      <meta httpEquiv="cache-control" content="no-cache" />
      <meta httpEquiv="cache-control" content="no-store" />
      <meta httpEquiv="cache-control" content="max-age=0" />
      <meta http-equiv="expires" content="Tue, 01 Jan 1980 1:00:00 GMT" />
      <meta httpEquiv="expires" content="0" />
      <meta httpEquiv="pragma" content="no-cache" />
      <div className={` h-full w-full bg-white`}>
        <HomeBanner banner={banner} />

        <link
          rel="alternate"
          hreflang="th"
          href="https://www.mylaundrythai.com/AboutUs/TH"
        />

        <div className={STYLE_MAX_WIDTH_DESKTOP}>
          {/* <HomeLaudryService /> */}
          {/* {loaded && <HomeProgram programs={programs} config={config} />} */}
          <HomeText />
          <HomeProgram programs={programs} config={config} />

          <HomeHowItWorks />
          <HomeFaq />
        </div>
        <HomeWelcome />
      </div>
    </React.Fragment>
  );
});

export default HomeMain;
